import {
  Documents,
  AcceptedPhotoId,
  MoneyBack,
  SharedDocument,
  User,
  DelayedFlight,
  Protect,
  Cancel,
  Law,
  MoneyPaper,
  Luggage,
  CancelledFlight,
} from "@airhelp/icons";
import {
  NumberOneIcon,
  NumberTwoIcon,
  NumberThreeIcon,
  EarthWithPlaneIcon,
  GraphIcon,
  PlaneUpIcon,
  CrossedPlaneIcon,
  PlaneWithClockIcon,
  PeopleIcon,
  ClockIcon,
} from "styles/icons";

export const icons = {
  XIcon: Cancel,
  LuggageIcon: Luggage,
  BanknotesIcon: MoneyPaper,
  GavelIcon: Law,
  BadgeCheckmarkIcon: Protect,
  CancelledFlightIcon: CancelledFlight,
  NumberOneIcon,
  NumberTwoIcon,
  NumberThreeIcon,
  EarthWithPlaneIcon,
  GraphIcon,
  PlaneUpIcon,
  CrossedPlaneIcon,
  PlaneWithClockIcon,
  PeopleIcon,
  ClockIcon,
  Documents,
  AcceptedPhotoId,
  MoneyBack,
  SharedDocument,
  User,
  DelayedFlight,
};
